module.exports = __webpack_public_path__ + "img/tommy-orange.b5e14693.png";